export default __webpack_public_path__ + "static/media/22_turtle.3690d678.JPG";